// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__36YuT","info":"Note_info__EG3_9","note":"Note_note__2tGl_","actions":"Note_actions__1QWgL"};